import { BiCheck } from "react-icons/bi";
import { BsEye, BsTrash } from "react-icons/bs";
import { GoPencil } from "react-icons/go";
import { LuArrowRightToLine, LuPrinter } from "react-icons/lu";
import { RxCross2 } from "react-icons/rx";
import classes from "./TableActionHandler.module.css";
import { MdLockReset } from "react-icons/md";
import { RiLockPasswordLine } from "react-icons/ri";

function TableActionHandler(props) {
  return (
    <div className={classes.tableActions}>
      {Object.entries(props).map(([key, handler]) => {
        const Icon = icons[key];
        return (
          Icon && (
            <div
              key={key}
              onClick={handler}
              className={classes?.iconDiv}
              datatype={squareShapes.includes(key) ? key : "basic"}
            >
              {Icon}
            </div>
          )
        );
      })}
    </div>
  );
}

export default TableActionHandler;

const icons = {
  onView: <BsEye title="View" />,
  onEdit: <GoPencil title="Edit" />,
  onDelete: <BsTrash />,
  onApprove: <BiCheck title="Activate" />,
  onReject: <RxCross2 title="Deactivate" />,
  onAssign: <LuArrowRightToLine title="Assign Staff" />,
  onPrint: <LuPrinter />,
  onChangeUserPassword: <RiLockPasswordLine title="Change User Password" />,
};

const squareShapes = ["onView", "onDelete", "onAssign", "onEdit"];
